<template>
    
    <v-simple-table dense :loading="loading">
        <tbody>
        <tr>
            <th>{{$t("PLATE_NUMBER")}}</th>
            <td>{{data.plateNumber}}</td>
        </tr>
        <tr>
            <th>{{$t("DRIVER_NAME")}}</th>
            <td>{{data.driverName}}</td>
            
        </tr>
        <tr>
            <th>{{$t("TRUCK_TYPE")}}</th>
            <td>{{data.truckType}}</td>
        </tr>

        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    props:{
        data:Object,
        loading:Boolean
    }
}
</script>

<style>

</style>